import HamburgerMenu from "./HamburgerMenu";
import React, {useCallback, useEffect, useMemo, useState} from "react";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import {getMachineHistories, getMachines} from "../Service/MachineService";
import Box from "@mui/material/Box";
import Machine from "./Machine/Machine";
import socket from "../Service/Socket";
import useMachineStore from "../Store/MachineStore";
import useTaskProcessingStore from "../Store/TaskProcessingStore";
import {DragDropContext} from "react-beautiful-dnd";
import _ from "lodash";
import {getTasks, traitementFile, updatePriorityTaskMachine} from "../Service/TaskService";
import {
    Backdrop,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Select,
    Snackbar
} from "@mui/material";
import DialogContentText from "@mui/material/DialogContentText";
import Alert from "@mui/material/Alert";
import TaskConfiguration from "./Machine/TaskConfiguration";
import MenuItem from "@mui/material/MenuItem";
import {PictureAsPdf} from "@mui/icons-material";
import MachinePreviewTasks from "./Machine/MachinePreviewTasks";
import QueueOrganizer from "./Machine/QueueOrganizer";
import {History} from "./History";
import Utils from "../Utils/Utils";
import CircularProgress from "@mui/material/CircularProgress";
import MachineDock from "./Dock/MachineDock";
import {reprintByCode} from "../Service/TaskService";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import Autocomplete from "@mui/material/Autocomplete";
import Stack from "@mui/material/Stack";
import {createThrottledRunner} from "../Utils/throttledRunner";
import {createUpdateBuffer} from "../Utils/updateBuffer";

// Taille de page fixée côté API (TaskRepository::getTaskHistories et getFinishedTasks).
const HISTORY_PAGE_SIZE = 20

const MACHINES_REFRESH_INTERVAL_MS = 5000

export default function Home() {
    const machines = useMachineStore(state => state.machines)
    const setMachinesFromSnapshot = useMachineStore(state => state.setMachinesFromSnapshot)
    const updateMachine = useMachineStore(state => state.updateMachine)
    const applySocketUpdate = useMachineStore(state => state.applySocketUpdate)
    const io = socket

    const [openDialogPowerOffMachine, setOpenDialogPowerOffMachine] = useState(false)
    const [openTaskConfiguration, setOpenTaskConfiguration] = useState(false)
    const [openPreview, setOpenPreview] = useState(false)
    const [previewFile, setPreviewFile] = useState(null)
    const [taskConfigurationFile, setTaskConfigurationFile] = useState(null)
    const [taskConfigurationMachine, setTaskConfigurationMachine] = useState(null)
    const [openErrorMessage, setOpenErrorMessage] = useState(false)
    const [machineFilters, setMachineFilters] = useState({
        technique: ""
    })
    const [previewMachine, setPreviewMachine] = useState(null)
    const [openPreviewMachine, setOpenPreviewMachine] = useState(false)
    const [previewTasks, setPreviewTasks] = useState(null)
    const [previewHasMore, setPreviewHasMore] = useState(false)
    const [showBackdrop, setShowBackdrop] = useState(false)
    const [locateRequest, setLocateRequest] = useState(null)
    const [highlightedMachineId, setHighlightedMachineId] = useState(null)
    const [organizerMachineId, setOrganizerMachineId] = useState(null)
    // Réimpression d'une planche abîmée : la douchette tape le code du QR dans le champ, Entrée
    // relance la planche en tête de file sur l'imprimante choisie ("" = celle du dernier passage).
    // Pas de fenêtre : le résultat s'affiche à côté du champ.
    const [scanInput, setScanInput] = useState("")
    const [scanPrinter, setScanPrinter] = useState("")
    const [scanBusy, setScanBusy] = useState(false)
    const [scanResult, setScanResult] = useState(null)
    const scanInputRef = React.useRef(null)
    const handleScanReprint = async () => {
        const code = scanInput.trim()
        if (!code || scanBusy) {
            return
        }
        setScanBusy(true)
        setScanResult(null)
        const res = await reprintByCode({code, printerNumber: scanPrinter || null, position: "first"})
        setScanResult({
            severity: res && res.response === "success" ? "success" : "error",
            message: (res && res.message) || "Réponse invalide de l'API d'impression."
        })
        setScanBusy(false)
        if (res && res.response === "success") {
            setScanInput("")
        }
        setTimeout(() => scanInputRef.current && scanInputRef.current.focus(), 50)
    }


    useEffect(() => {
        const refreshMachines = createThrottledRunner(() => {
            const requestedAt = Date.now()
            return getMachines().then(response => {
                if (response.fetchedMachines) {
                    setMachinesFromSnapshot(response.fetchedMachines, requestedAt)
                }
            })
        }, MACHINES_REFRESH_INTERVAL_MS)

        const updates = createUpdateBuffer(applySocketUpdate)

        const applyMachineUpdates = (machinesData) => {
            machinesData.forEach(updates.push)
        }

        const handleMachineUpdate = (data) => {
            applyMachineUpdates(Array.isArray(data) ? data : [data])
        }

        const handleMachinesBatchUpdate = (data) => {
            if (data && Array.isArray(data.machines)) {
                applyMachineUpdates(data.machines)
            }
        }

        const handleTaskAdded = (data) => {
            if (data.machineId && data.tasks) {
                updateMachine(data)
            }
        }

        // Pendant une vague maboutiquepro, machineProgress arrive jusqu'à 49 fois par minute : un rechargement complet
        // (113 Ko, ~2 s) toutes les 5 s au plus suffit, et le dernier part après la fin de la vague.
        const handleMachineProgress = () => refreshMachines.request()

        // Les événements émis pendant une coupure réseau sont perdus : on recharge à la reconnexion et au retour sur l'écran.
        const handleReconnect = () => refreshMachines.request()

        const handleVisibilityChange = () => {
            if (document.visibilityState === "visible") {
                refreshMachines.request()
            }
        }

        const handleWindowBatchUpdate = (event) => handleMachinesBatchUpdate(event.detail)

        refreshMachines.request()
        io.on("machineUpdate", handleMachineUpdate)
        io.on("machinesBatchUpdate", handleMachinesBatchUpdate)
        io.on("taskAdded", handleTaskAdded)
        io.on("machineProgress", handleMachineProgress)
        io.io.on("reconnect", handleReconnect)
        document.addEventListener("visibilitychange", handleVisibilityChange)
        window.addEventListener("machinesBatchUpdate", handleWindowBatchUpdate)

        return () => {
            refreshMachines.cancel()
            updates.cancel()
            io.off("machineUpdate", handleMachineUpdate)
            io.off("machinesBatchUpdate", handleMachinesBatchUpdate)
            io.off("taskAdded", handleTaskAdded)
            io.off("machineProgress", handleMachineProgress)
            io.io.off("reconnect", handleReconnect)
            document.removeEventListener("visibilitychange", handleVisibilityChange)
            window.removeEventListener("machinesBatchUpdate", handleWindowBatchUpdate)
        }
    }, [io, setMachinesFromSnapshot, updateMachine, applySocketUpdate]);

    const combineTasks = (allTasks, pendingTasks) => [
        ...allTasks.filter(t => +t.status !== 3),
        ...pendingTasks
    ];

    const impressionTechniques = useMemo(() => {
        const techniques = machines.map(m => {
            return {
                value: m.printingTechnique.id,
                label: m.printingTechnique.name
            }
        })

        return _.uniqBy(techniques, "value")
    }, [machines])

    const filteredMachines = useMemo(() => {
        return machines.filter(m => {
            if (machineFilters.technique) {
                return m.printingTechnique.id === machineFilters.technique
            }

            return true
        })
    }, [machines, machineFilters])

    // La carte peut ne pas être encore rendue si le filtre de technique vient d'être levé : on réessaie au rendu suivant.
    useEffect(() => {
        if (!locateRequest) {
            return
        }

        const card = document.getElementById(`machine-card-${locateRequest.machineId}`)
        if (!card) {
            return
        }

        const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches
        card.scrollIntoView({behavior: reduceMotion ? "auto" : "smooth", block: "start"})
        setHighlightedMachineId(locateRequest.machineId)
        setLocateRequest(null)
    }, [locateRequest, filteredMachines]);

    useEffect(() => {
        if (highlightedMachineId === null) {
            return
        }

        const timer = setTimeout(() => setHighlightedMachineId(null), 2000)
        return () => clearTimeout(timer)
    }, [highlightedMachineId]);

    const handleCloseDialogPowerOffMachine = () => {
        setOpenDialogPowerOffMachine(false)
    }

    const onDropFile = useCallback(async (event, machine) => {
        if (!machine.power) {
            setOpenDialogPowerOffMachine(true)
            return
        }

        const validFiles = await Utils.getAllDroppedFiles(event.dataTransfer.items)

        if (validFiles.length > 0) {
            setTaskConfigurationFile(validFiles)
            setTaskConfigurationMachine(machine)
            setOpenTaskConfiguration(true)
        } else {
            alert('Only PDF and image files are allowed.');
        }
    }, [])

    const onDragEnd = (result) => {
        const {destination, source, draggableId} = result;

        // Si l'élément est déposé en dehors des colonnes
        if (!destination) {
            return;
        }

        // Si l'élément est déposé à la même position
        if (
            destination.droppableId === source.droppableId &&
            destination.index === source.index
        ) {
            return;
        }

        const sourceMachine = _.find(machines, {id: +source.droppableId});
        const destinationMachine = _.find(machines, {id: +destination.droppableId});

        if (!destinationMachine.power) {
            return
        }

        const sourceTasks = Array.from(sourceMachine.tasks).filter(t => +t.status === 3);
        const destinationTasks = Array.from(destinationMachine.tasks).filter(t => +t.status === 3);

        if (sourceMachine.id === destinationMachine.id) {
            const [movedItem] = sourceTasks.splice(source.index, 1);
            sourceTasks.splice(destination.index, 0, movedItem)
            sourceTasks.map((t, i) => {
                t.priority = i + 1
                return t
            })

            // Envoyer la mise à jour au serveur sans mettre à jour l'UI localement
            // L'UI sera mise à jour via WebSocket pour tous les clients
            updatePriorityTaskMachine({
                typeDrop: "changePriority",
                targetMachineId: sourceMachine.id,
                orders: sourceTasks.map(data => {
                    return {
                        "taskId": data.id,
                        "priority": data.priority
                    }
                })
            }).then(response => {
                // Si erreur, rétablir l'ordre précédent
                if (response.response === "error") {
                    console.error("Erreur lors de la mise à jour des priorités:", response.error);
                    // Recharger les machines pour avoir l'état correct
                    window.location.reload();
                }
            }).catch(error => {
                console.error("Erreur réseau:", error);
                window.location.reload();
            });
            
            // Mise à jour optimiste temporaire pour fluidité
            // Sera écrasée par la vraie mise à jour WebSocket
            updateMachine({
                ...sourceMachine,
                tasks: combineTasks(sourceMachine.tasks, sourceTasks)
            })
        } else {
            const [movedItem] = sourceTasks.splice(source.index, 1);
            destinationTasks.splice(destination.index, 0, movedItem);

            sourceTasks.map((t, i) => {
                t.priority = i + 1
                return t
            })

            destinationTasks.map((t, i) => {
                t.priority = i + 1
                return t
            })

            // Mise à jour optimiste temporaire pour fluidité
            sourceMachine.tasks = combineTasks(sourceMachine.tasks, sourceTasks);
            destinationMachine.tasks = combineTasks(destinationMachine.tasks, destinationTasks);
            
            // Mise à jour immédiate de l'UI
            updateMachine({
                ...sourceMachine,
                tasks: sourceMachine.tasks
            });
            updateMachine({
                ...destinationMachine,
                tasks: destinationMachine.tasks
            });

            // Envoyer au serveur
            updatePriorityTaskMachine({
                typeDrop: "changeTaskMachine",
                taskId: draggableId,
                targetMachineId: destinationMachine.id,
                orders: destinationTasks.map(data => {
                    return {
                        "taskId": data.id,
                        "priority": data.priority
                    }
                })
            }).then(response => {
                if (response.response === "error") {
                    console.error("Erreur lors du transfert:", response.error);
                    window.location.reload();
                }
                // La vraie mise à jour viendra via WebSocket pour tous les clients
            }).catch(error => {
                console.error("Erreur réseau:", error);
                window.location.reload();
            })
        }
    }

    const handleCloseErrorMessage = () => {
        setOpenErrorMessage(false)
    }

    const handleOpenPreviewFile = useCallback((task) => {
        if (!task.previewUrl) {
            return
        }
        setPreviewFile(task.previewUrl)
        setOpenPreview(true)
    }, [])

    const showMachineHistories = useCallback((machine, tasks) => {
        setPreviewTasks(tasks)
        setPreviewHasMore(tasks.length === HISTORY_PAGE_SIZE)
        setPreviewMachine(machine)
        setOpenPreviewMachine(true)
    }, [])

    const handleOrganizeQueue = useCallback((machine) => {
        setOrganizerMachineId(machine.id)
    }, [])

    const handleCloseOrganizer = useCallback(() => {
        setOrganizerMachineId(null)
    }, [])

    const handleOpenMachineTasks = useCallback((machine) => {
        setPreviewTasks(null)
        setPreviewMachine(machine)
        setOpenPreviewMachine(true)
    }, [])

    const handleLocateMachine = useCallback((machine) => {
        if (machineFilters.technique && machine.printingTechnique.id !== machineFilters.technique) {
            setMachineFilters({...machineFilters, technique: ""})
        }

        setLocateRequest({machineId: machine.id})
    }, [machineFilters])

    return (
        <>
            <HamburgerMenu/>
            <MachineDock
                onOpenTasks={handleOpenMachineTasks}
                onLocateMachine={handleLocateMachine}
            />

            <Dialog
                open={openDialogPowerOffMachine}
                onClose={handleCloseDialogPowerOffMachine}
            >
                <DialogTitle id="alert-dialog-title" sx={{display: "flex", alignItems: "center", gap: 1}}>
                    Imprimante éteinte
                </DialogTitle>
                <DialogContent>
                    <Alert severity="error">
                        <DialogContentText id="alert-dialog-description">
                            L'imprimante qui va imprimer les fichiers est éteinte.
                        </DialogContentText>
                    </Alert>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialogPowerOffMachine} autoFocus>
                        Ok
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={openPreview}
                fullWidth
                onClose={() => {
                    setOpenPreview(false)
                }}
            >
                <DialogContent>
                    <img src={previewFile} style={{width: "100%"}}/>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => {
                        setOpenPreview(false)
                    }}>
                        Fermer
                    </Button>
                </DialogActions>
            </Dialog>


            <Snackbar
                anchorOrigin={{vertical: "bottom", horizontal: "center"}}
                open={openErrorMessage}
                onClose={handleCloseErrorMessage}
                autoHideDuration={2000}
            >
                <Alert
                    onClose={handleCloseErrorMessage}
                    severity="error"
                    variant="filled"
                    sx={{width: '100%'}}
                >
                    Une erreur s'est produite pendant l'upload du fichier
                </Alert>
            </Snackbar>

            <Backdrop style={{zIndex: 9999}} open={showBackdrop}>
                <CircularProgress color="inherit"/>
            </Backdrop>

            {openTaskConfiguration && taskConfigurationFile && taskConfigurationFile.length &&
                <TaskConfiguration
                    openTaskConfiguration={openTaskConfiguration}
                    setOpenTaskConfiguration={setOpenTaskConfiguration}
                    files={taskConfigurationFile}
                    machine={taskConfigurationMachine}
                    onErrorUpload={() => {
                        setOpenErrorMessage(true)
                    }}
                    onsubmit={(filesData) => {
                        setShowBackdrop(true)
                        Promise.all(filesData.map(fileData => {
                            const formData = new FormData()
                            formData.append("theFile", fileData.theFile)
                            formData.append("typeDrop", fileData.typeDrop)
                            formData.append("printingTechnique", fileData.printingTechnique)
                            formData.append("printerNumber", fileData.printerNumber)
                            formData.append("numberPrint", fileData.numberPrint)
                            formData.append("pngConvert", fileData.pngConvert)
                            if (fileData.width && fileData.height) {
                                formData.append("width", fileData.width)
                                formData.append("height", fileData.height)
                            }

                            return traitementFile(formData)
                        }))
                            .then()
                            .finally(() => {
                                setOpenTaskConfiguration(false)
                                setShowBackdrop(false)
                            })
                    }}
                />
            }

            {organizerMachineId !== null &&
                <QueueOrganizer
                    machineId={organizerMachineId}
                    onClose={handleCloseOrganizer}
                    onPreviewFile={handleOpenPreviewFile}
                />
            }

            {openPreviewMachine &&
                <MachinePreviewTasks
                    machine={previewMachine}
                    tasks={previewTasks}
                    hasMore={previewHasMore}
                    open={openPreviewMachine}
                    setOpen={setOpenPreviewMachine}
                    onLoadNext={() => {
                        const nextPage = Math.ceil(previewTasks.length / HISTORY_PAGE_SIZE) + 1
                        const request = previewMachine
                            ? getMachineHistories(previewMachine.id, nextPage).then(response => response.data)
                            : getTasks(nextPage).then(response => response.fetchedTasks || [])

                        request.then(nextTasks => {
                            setPreviewTasks([...previewTasks, ...nextTasks])
                            setPreviewHasMore(nextTasks.length === HISTORY_PAGE_SIZE)
                        }).catch(() => setPreviewHasMore(false))
                    }}
                />
            }

            <Grid2 container>
                <Grid2 xs={9}>
                    <Box sx={{px: 4, py: 2, textAlign: "left"}}>
                        {/* Filtre « Technique d'impression » masqué le 2026-10-16 : pas encore utilisé par l'atelier.
                            Le filtre (machineFilters.technique) reste en place pour le remettre d'un bloc. */}
                        <Stack direction={{xs: "column", md: "row"}} spacing={2} alignItems={{md: "center"}}>
                            <Button
                                variant="contained"
                                startIcon={<PictureAsPdf/>}
                                color="primary"
                                sx={{height: 40, whiteSpace: "nowrap", flexShrink: 0}}
                                onClick={() => {
                                    setPreviewTasks(null)
                                    setPreviewMachine(null)
                                    setOpenPreviewMachine(true)
                                }}
                            > Impressions encours</Button>
                            {/* Réimpression d'une planche abîmée : un seul bloc, scan + imprimante + résultat,
                                tous à la même hauteur que le bouton. */}
                            <Stack
                                direction={{xs: "column", md: "row"}}
                                spacing={1.5}
                                alignItems={{md: "center"}}
                                sx={{
                                    flex: 1,
                                    minWidth: 0,
                                    px: 1.5,
                                    py: 1,
                                    borderRadius: 1,
                                    border: "1px solid",
                                    borderColor: "divider",
                                    bgcolor: "grey.50",
                                }}
                            >
                                <TextField
                                    inputRef={scanInputRef}
                                    size="small"
                                    label="Réimprimer une planche"
                                    placeholder="Scanner le QR de la planche"
                                    value={scanInput}
                                    disabled={scanBusy}
                                    onChange={(e) => setScanInput(e.target.value)}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            e.preventDefault()
                                            handleScanReprint()
                                        }
                                    }}
                                    inputProps={{autoComplete: "off", spellCheck: false}}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                {scanBusy ? <CircularProgress size={18}/> : <QrCodeScannerIcon color="action"/>}
                                            </InputAdornment>
                                        )
                                    }}
                                    sx={{flex: "1 1 320px", minWidth: 260, bgcolor: "background.paper"}}
                                />
                                <Autocomplete
                                    size="small"
                                    options={(machines || []).filter(m => m.power)}
                                    getOptionLabel={(m) => `${m.number} — ${m.name}`}
                                    isOptionEqualToValue={(a, b) => a.id === b.id}
                                    value={(machines || []).find(m => String(m.number) === scanPrinter) || null}
                                    onChange={(e, m) => setScanPrinter(m ? String(m.number) : "")}
                                    noOptionsText="Aucune imprimante allumée ne correspond"
                                    sx={{flex: "0 1 300px", minWidth: 240, bgcolor: "background.paper"}}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Imprimante"
                                            placeholder="Celle du dernier passage"
                                        />
                                    )}
                                />
                                {scanResult &&
                                    <Alert
                                        severity={scanResult.severity}
                                        onClose={() => setScanResult(null)}
                                        sx={{flex: "1 1 280px", minWidth: 0, py: 0, alignItems: "center", "& .MuiAlert-message": {py: "6px"}}}
                                    >
                                        {scanResult.message}
                                    </Alert>
                                }
                            </Stack>
                        </Stack>
                    </Box>
                    <Box sx={{px: 4}}>
                        <Grid2 container spacing={2}>
                            <DragDropContext onDragEnd={onDragEnd}>
                                <>
                                    {filteredMachines.map(machine => (
                                        <Grid2 key={machine.id} xs={3}>
                                            <Machine
                                                machine={machine}
                                                highlighted={highlightedMachineId === machine.id}
                                                onDropFinish={onDropFile}
                                                onPreviewFileTask={handleOpenPreviewFile}
                                                onPreviewMachineTask={handleOpenMachineTasks}
                                                onPreviewHistories={showMachineHistories}
                                                onOrganizeQueue={handleOrganizeQueue}
                                            />
                                        </Grid2>
                                    ))}
                                </>
                            </DragDropContext>
                        </Grid2>
                    </Box>
                </Grid2>
                <Grid2 xs>
                    <History
                        onPreviewFileTask={handleOpenPreviewFile}
                        onPreviewTasks={(tasks) => {
                            setPreviewMachine(null)
                            setPreviewTasks(tasks)
                            setPreviewHasMore(tasks.length > 0 && tasks.length % HISTORY_PAGE_SIZE === 0)
                            setOpenPreviewMachine(true)
                        }}
                    />
                </Grid2>
            </Grid2>
        </>
    )
}
